import { DeesElement, property, html, customElement, TemplateResult } from '@designestate/dees-element';
import * as domtools from '@designestate/dees-domtools';

import { SioCombox } from './sio-combox';
SioCombox;

@customElement('sio-fab')
export class SioFab extends DeesElement {
  @property()
  public showCombox = false;

  public static demo = () => html`
    <sio-fab .showCombox=${true}></sio-fab>
  `;

  constructor() {
    super();
    domtools.DomTools.setupDomTools();
  }

  public render(): TemplateResult {
    return html`
      ${domtools.elementBasic.styles}
      <style>
        :host {
          will-change: transform;
          position: absolute;
          display: block;
          bottom: 20px;
          right: 20px;
          z-index: 10000;
          color: #fff;
        }

        #mainbox {
          position: absolute;
          bottom: 0px;
          right: 0px;
          height: 60px;
          width: 60px;
          box-shadow: 0px 0px 5px rgba(0,0,0,0.3);
          text-align: center;
          color: #CCC;
          cursor: pointer;
          background: ${this.goBright ? 'linear-gradient(-45deg, #fafafa, #eeeeee)' : 'linear-gradient(-45deg, #222222, #333333)'};
          border-radius: 50% 50% 50% 50%;
          user-select: none;
        }

        #mainbox img {
          transition: all 0.2s;
          filter: ${this.showCombox? 'grayscale(0)' : 'grayscale(1)'};
          padding: 20%;
          height: 100%;
          width: 100%;
          object-fit: contain;
          will-change: transform;
          transform: ${this.showCombox? 'rotate(0deg)' : 'rotate(-360deg)'};
          -webkit-user-drag: none;
          -khtml-user-drag: none;
          -moz-user-drag: none;
          -o-user-drag: none;
          user-drag: none;
        }

        #mainbox:hover img {
          filter: grayscale(0);
        }

        #comboxContainer sio-combox {
          transition: all 0.2s;
          bottom: 60px;
          opacity: 0;
          pointer-events: none;
        }

        #comboxContainer.show sio-combox {
          bottom: 80px;
          opacity: 1;
          pointer-events: all;
        }
      </style>
      <div id="mainbox" @click=${this.toggleCombox}>
        <img src="https://assetbroker.lossless.one/brandfiles/00general/favicon_socialio.svg">
      </div>
      <div id="comboxContainer"  class="${this.showCombox ? 'show' : null}">
        <sio-combox></sio-combox>
      </div>
    `;
  }

  /**
   * toggles the combox
   */
  public async toggleCombox() {
    console.log('toggle combox');
    this.showCombox = !this.showCombox;
  }

  public firstUpdated() {
    const sioCombox: SioCombox = this.shadowRoot.querySelector('sio-combox');
    const mainBox: HTMLElement = this.shadowRoot.querySelector('#mainbox');
    sioCombox.referenceObject = mainBox;
  }
}